import React from 'react';
import { useController, FieldValues, UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputPassword } from '../../_new/InputPassword';

interface Props<T extends FieldValues> extends UseControllerProps<T> {
	placeholder?: string;
	required?: boolean;
	autoComplete?: string;
}

const ValidatePassword = <T extends FieldValues>(props: Props<T>) => {
	const { name, placeholder, control, required = false, rules, autoComplete } = props;
	const { t } = useTranslation();

	const {
		field,
		fieldState: { error },
	} = useController({
		name,
		control,
		rules: {
			required: required ? `${placeholder} ${t('misc.forms.isRequired')}` : false,
			...rules,
		},
	});

	return (
		<div className="validate-password">
			<InputPassword
				{...field}
				id={field.name}
				className="w-full"
				placeholder={placeholder}
				autoComplete={autoComplete}
				invalid={!!error}
			/>
			{error && <small className="p-error font-bold ml-3">{error.message}</small>}
		</div>
	);
};

export default ValidatePassword;
